function order_flats_table(){

    let $table = $('.flats-table tbody');

    let order_by = $('.js-flats-table-order.active').data('order');
    let order = $('.js-flats-table-order.active').hasClass('asc') ? 'asc' : 'desc';

    let $rows = $table.find('tr').toArray().sort(function(rowA, rowB) {
        let orderA = parseInt($(rowA).data(order_by));
        let orderB = parseInt($(rowB).data(order_by));
        if(order == 'asc'){
            return orderA - orderB;
        }else{
            return orderB - orderA;
        }
    });

    // Odstránenie existujúcich riadkov z tabuľky
    $table.empty();

    // Pridanie zoradených riadkov späť do tabuľky
    $.each($rows, function(index, row) {
        $table.append(row);
    });
}

$(document).ready(function() {

    /*
    $( '.js-icon-wrapper' ).hover(function() {
            $("img.first_image", this).hide();
            $('img.hide', this).show();
        }, function() {
            $("img.first_image", this).show();
            $('img.hide', this).hide();
        }
    );
    */

    $(document).on('click', '.js-flats-table-order', function(){

        if($(this).hasClass('asc')){
            $(this).removeClass('asc').addClass('desc');
        }else if($(this).hasClass('desc')){
            $(this).removeClass('desc').addClass('asc');
        }else{
            $('.js-flats-table-order.active').removeClass('active desc asc');
            $(this).addClass('active').addClass('asc');
        }

        order_flats_table();
    });

    $('.js-floor-select a').hover(function() {
        let floor = $(this).data('floor');
        $('#poschodia a:nth-child(' + floor + ') .building-floor').addClass('hovered');
        $('.js-floor-flats-info-all').hide();
        $('.js-floor-flats-info[data-floor="'+ floor +'"]').show();
    }, function() {
        $('#poschodia a .building-floor').removeClass('hovered');
        $('.js-floor-flats-info').hide();
        $('.js-floor-flats-info-all').show();
    });

    $('#poschodia .building-floor').hover(function() {
        let floor = $(this).data('floor');
        $('.js-floor-select a[data-floor="' + floor + '"] div').addClass('hovered');
        $('.js-floor-flats-info-all').hide();
        $('.js-floor-flats-info[data-floor="'+ floor +'"]').show();
    }, function() {
        $('.js-floor-select a div').removeClass('hovered');
        $('.js-floor-flats-info').hide();
        $('.js-floor-flats-info-all').show();
    });

    $('.js-custom-select').click(function(){
        if($(this).hasClass('disabled')){
            return;
        }
        $(this).toggleClass('open');
        $(this).next('.custom-select-tab').slideToggle();
    })

    $('.custom-select-tab > div').click(function(){
        $(this).addClass('selected');
        $('.custom-select-tab').slideUp();
        let text = $(this).data('text');
        let value = $(this).data('value');
        if(text){
            $('.js-selected-value').text(text);
            $('.js-selected-value').attr('data-value', value);
        }
        $('.js-custom-select').removeClass('open');


        if($('.js-gallery').length){
            gallery_filter();
        }else{
            flat_filter();
        }
    })

    $('.js-flats-filter-price').on('input', function(){
        set_range_filter($(this), 1);
    });

    $('.js-flats-filter-interior').on('input', function(){
        set_range_filter($(this), 2);
    });

    $('.js-flats-filter-price, .js-flats-filter-interior').on('change', function(){
        flat_filter();
    });

    $('.js-flats-filter-rooms, .js-flats-filter-floors, .js-flats-filter-blocks').on('click', function(){
        if($(this).hasClass('active')){
            $(this).removeClass('active');
        }else{
            $(this).addClass('active');
        }
        flat_filter();
    });

    if($('#run_filter').length){
        flat_filter();
    }

    $('.js-floor-plan-flat').hover(function(){
       let hovered_flat = 10;
       $('.flat-data:visible').fadeOut(function(){
        $('.flat-data-'+hovered_flat).fadeIn();
       })
    });

    $('.js-show-flat-data').hover(function() {

        $('.js-show-flat-data.hovered').removeClass('hovered');
        $('span', this).addClass('hovered');
        let flat_id = $(this).data('flat-id');
        $('.flat-data').hide();

        let info_box = $('.flat-data[data-flat-id="' + flat_id + '"]');

        let parentElement = $('.floor-plan-svg')[0];

        let svgBox = $(this)[0].getBoundingClientRect();
        let parentBox = parentElement.getBoundingClientRect();

        let relativeTop = svgBox.top - parentBox.top;
        let relativeLeft = svgBox.left - parentBox.left;

        let left = relativeLeft + $('g', this)[0].getBBox().width;

        if(left > 550){
            left = relativeLeft - info_box.width() - 30;
            info_box.addClass('left-side');
        }

        info_box.css({
            top: relativeTop - 70,
            left: left
        }).show();
    });

    $('.floor-plan-svg').mouseleave(function(){
        $('.flat-data').hide();
    })

});


function flat_filter(){
    let count = 0;

    let flats = $('.js-flat-row');
    let selected_rooms = [];
    let selected_floors = [];
    let selected_blocks = [];

    let selected_status = $('.js-flats-filter-status.active').data('status');

    let selected_rooms_buttons = $('.js-flats-filter-rooms.active');

    selected_rooms_buttons.each(function(){
        selected_rooms.push($(this).data('rooms'));
    });

    let selected_floors_buttons = $('.js-flats-filter-floors.active');

    selected_floors_buttons.each(function(){
        selected_floors.push($(this).data('floor'));
    });

    let selected_blocks_buttons = $('.js-flats-filter-blocks.active');

    selected_blocks_buttons.each(function(){
        selected_blocks.push($(this).data('block'));
    });

    let selected_price_from = parseInt( $('.js-price-filter-input.input-min').val() );
    let selected_price_to = parseInt( $('.js-price-filter-input.input-max').val() );

    let selected_interior_from = parseInt( $('.js-interior-filter-input.input-min').val() );
    let selected_interior_to = parseInt( $('.js-interior-filter-input.input-max').val() );

    flats.each(function(){
        let flat = $(this);
        let flat_floor = flat.data('floor');
        let flat_rooms = flat.data('rooms');
        let flat_block = flat.data('block');
        let flat_price = flat.data('price');
        let flat_interior = flat.data('interior');
        let flat_status = flat.data('status');

        if(
            (!selected_floors.length || jQuery.inArray(flat_floor, selected_floors) !== -1)
            && (!selected_rooms.length || jQuery.inArray(flat_rooms, selected_rooms) !== -1)
            && (!selected_blocks.length || jQuery.inArray(flat_block, selected_blocks) !== -1)
            && (!flat_price || (
                (selected_price_from <= flat_price)
                && (selected_price_to >= flat_price)
            ))
            && (!flat_interior || (
                (selected_interior_from <= flat_interior)
                && (selected_interior_to >= flat_interior)
            ))
            && (!selected_status || selected_status === flat_status)
        ){
            flat.show();
            count++;
        }else{
            flat.hide();
        }
    });

    order_flats_table();

    if(count === 0){
        $('.js-flats-filter-empty').show();
    }else{
        $('.js-flats-filter-empty').hide();
    }
}

$(document).on('click', '.js-flats-filter-status:not(.active)', function(){
    $('.js-flats-filter-status.active').removeClass('active');
    $(this).addClass('active');
    flat_filter();
})

$('.js-reset-filters').click(function(){

    $('.js-flats-filter-rooms, .js-flats-filter-floors, .js-flats-filter-blocks').removeClass('active');
    $('.custom-select-tab > div[data-value="0"]').click();

    $('.js-flats-filter-form').trigger('reset');

    set_range_filter($('.js-flats-filter-price.range-min'));
    set_range_filter($('.js-flats-filter-price.range-max'));
    set_range_filter($('.js-flats-filter-interior.range-min'), 2);
    set_range_filter($('.js-flats-filter-interior.range-max'), 2);
    $('.js-price-filter-progress').css('left', '0').css('right', '0');
    $('.js-interior-filter-progress').css('left', '0').css('right', '0');

    flat_filter();
})


/* gallery filter */

$(document).on('click', '.js-gallery-place:not(.active)', function(){
    $('.js-gallery-place.active').removeClass('active');
    $(this).addClass('active');
    gallery_filter();
})

$(document).on('change', '.js-gallery-rooms', function(){
    //gallery_filter();
});

function gallery_filter(){
    let place = $('.js-gallery-place.active').data('place');
    let rooms = $('.js-gallery-rooms').attr('data-value');

    if(place === 'exterior'){
        // $('.custom-select-tab div[data-value="0"]').click();
        $('.custom-select-tab').hide();
        $('.js-custom-select').addClass('disabled');
    }else{
        $('.js-custom-select').removeClass('disabled');
    }

    $('.js-gallery-item').show();

    if(place || rooms > 0){
        if(place){
            $('.js-gallery-item[data-place!="' + place + '"]').hide();
        }
        if(rooms > 0){
            if(place != 'exterior'){
                $('.js-gallery-item[data-rooms!="' + rooms + '"]').hide();
            }
        }

        if(rooms > 0 || place === 'exterior'){
            $('.js-gallery-item:visible').each(function(index){

                console.log(index);

                var classes = $(this).attr('class').split(' ').filter(function(c) {
                    return !/^col-/.test(c);
                });
                $(this).attr('class', classes.join(' '));

                var half_width = [0, 1, 5, 6, 10, 11, 12];
                if (half_width.includes(index)) {
                    $(this).addClass('col-md-6');
                }else {
                    $(this).addClass('col-md-4');
                }
            });
        }
    }else{
        $('.js-gallery-item').each(function(index){
            var classes = $(this).attr('class').split(' ').filter(function(c) {
                return !/^col-/.test(c);
            });
            $(this).attr('class', classes.join(' '));
            $(this).addClass($(this).data('default-class'));
        });
    }
}

const rangeInput = $('.js-price-filter-range');
if(rangeInput.length){

    const priceInput = $('.js-price-filter-input');
    const progress = $('.js-price-filter-progress');
    let priceGap = 0;

    const overlapping = (rangeInput[1].max - rangeInput[0].min) * 0.1;

    $(document).on('input', '.js-price-filter-range' ,function(){
        let minVal = parseInt(rangeInput[0].value);
        let maxVal = parseInt(rangeInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(rangeInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                rangeInput[0].value = maxVal - priceGap
            }else{
                rangeInput[1].value = minVal + priceGap;
            }
        }else{
            priceInput[0].value = minVal;
            priceInput[1].value = maxVal;
            let new_left = (minVal - rangeInput[0].min) / (rangeInput[1].max - rangeInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != rangeInput[1].max){
                new_right = 100 - ((maxVal - rangeInput[0].min ) / (parseInt(rangeInput[0].min) - rangeInput[0].max )) * 100 * -1 + '%'
            }
            progress.css('left', new_left);
            progress.css('right', new_right);

        }
    });
}

const interiorFilterInput = $('.js-interior-filter-range');
if(interiorFilterInput.length){

    const interiorInput = $('.js-interior-filter-input');
    const interiorProgress = $('.js-interior-filter-progress');
    let priceGap = 0;

    const overlapping = (interiorFilterInput[1].max - interiorFilterInput[0].min) * 0.1;

    $(document).on('input', '.js-interior-filter-range' ,function(){
        let minVal = parseInt(interiorFilterInput[0].value);
        let maxVal = parseInt(interiorFilterInput[1].value);

        if($(this).hasClass('range-min')){
            if(maxVal - minVal < overlapping ){
                $(interiorFilterInput[0]).css('z-index', 1);
            }
        }else{
            if(maxVal - minVal < overlapping ){
                $(interiorFilterInput[0]).css('z-index', '');
            }
        }

        if((maxVal - minVal) < priceGap){
            if($(this).hasClass('range-min')){
                interiorFilterInput[0].value = maxVal - priceGap
            }else{
                interiorFilterInput[1].value = minVal + priceGap;
            }
        }else{
            interiorInput[0].value = minVal;
            interiorInput[1].value = maxVal;
            let new_left = (minVal - interiorFilterInput[0].min) / (interiorFilterInput[1].max - interiorFilterInput[0].min) * 100 + "%";

            let new_right = 0
            if(maxVal != interiorFilterInput[1].max){
                new_right = 100 - ((maxVal - interiorFilterInput[0].min ) / (parseInt(interiorFilterInput[0].min) - interiorFilterInput[0].max )) * 100 * -1 + '%'
            }
            interiorProgress.css('left', new_left);
            interiorProgress.css('right', new_right);

        }
    });
}

function set_range_filter(range_filter, type = 1){
    let value = range_filter.val();
    let formatted_value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if(type === 1){
        if(range_filter.hasClass('range-min')){
            $('.js-flats-price-filter-value-min').text(formatted_value);
        }else{
            $('.js-flats-price-filter-value-max').text(formatted_value);
        }
    }else{
        if(range_filter.hasClass('range-min')){
            $('.js-flats-interior-filter-value-min').text(formatted_value);
        }else{
            $('.js-flats-interior-filter-value-max').text(formatted_value);
        }
    }

}
